import React, { useState, useEffect } from 'react';
import { useMobile } from '../../../hooks/useMobile';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useLinesContext } from '../../../contexts/Lines';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { v4 as uuidv4 } from 'uuid';
import { createOnboardingLine } from '../../../utils/line';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Step from '../BuildingBlocks/Stepper/Step';
import ExampleLineDesktop from '../Line/Desktop/ExampleLineDesktop';
import Typography from '@material-ui/core/Typography';
import MobileStages from '../../BuildingBlocks/Lines/Mobile/Stages';
import { LINE_EXPLAINED_WE_PROVIDE } from '../messages';

const useStyles = makeStyles((theme) => ({
  timeline: { marginTop: theme.spacing(6) },
}));

export default function LineExplained() {
  const mobile = useMobile('sm');
  const classes = useStyles();
  const { trackEvent } = useEventTrackerContext();
  const { goForward } = useOnboardingContext();
  const { products, lines } = useLinesContext();

  const [line, setLine] = useState(null);
  const newestProduct = products[products?.length - 1];

  async function handleSubmit() {
    trackEvent({ event: 'goals_completed' });
    goForward();
  }

  useEffect(() => {
    const lineId = uuidv4();
    const lineName = newestProduct.name + ' #' + (lines ? lines.length + 1 : 1);
    const newLine = createOnboardingLine(lineId, newestProduct, lineName);
    setLine(newLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Step
      initialValues={{}}
      onSubmit={handleSubmit}
      component={() => {
        return (
          <>
            {line && (
              <>
                {mobile && <MobileStages line={line} />}
                {!mobile && (
                  <ExampleLineDesktop
                    line={line}
                    className={classes.timeline}
                  />
                )}
                <Typography variant="subtitle2">
                  {LINE_EXPLAINED_WE_PROVIDE}
                </Typography>
              </>
            )}
          </>
        );
      }}
    />
  );
}
